var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeachingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Misc/Teaching/24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Misc/Teaching/24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teaching",
    transform: "translate(4.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9749758,4.8723157 C8.00502201,4.87709327 8.03423361,4.87804878 8.06261059,4.87804878 C8.4356844,4.87804878 8.75784657,4.55795163 8.80208127,4.12510385 C8.80458513,4.10694909 9.0090663,2.3373374 9.94467199,1.53661678 C10.2743457,1.2556957 10.3419497,0.719652418 10.0957377,0.342224439 C9.84869103,-0.033292512 9.38380934,-0.113555677 9.05246638,0.170231942 C7.59439044,1.41717754 7.33232069,3.82316147 7.32230529,3.92540145 C7.2738975,4.39360325 7.56684807,4.81689589 7.9749758,4.8723157",
    id: "Fill-1",
    fill: "#DB3725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04653668,18.4693933 C10.0536172,18.6551973 9.85758035,19.9994352 11.2305408,19.9994352 C12.339466,20.0502259 15.2937127,16.673595 16.0645851,10.7050441 C16.6762702,4.0351175 8.58197311,6.99661308 8.06053448,6.99661308 C7.53909585,6.99661308 4.4139576,6.01332428 2.68321515,6.50496868 C0.952472692,6.99661308 -0.603416557,8.03877934 0.23281247,12.0907364 C1.06410113,16.2192675 3.24499252,19.9994352 4.78484771,19.9994352 C6.32470289,19.9994352 6.02178354,18.4693933 8.04653668,18.4693933 Z",
    id: "Path-35",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.9014295 L3.65853659,11.9014295 C2.6935475,14.048444 3.04919479,15.1219512 4.72547848,15.1219512 C6.05812718,15.1219512 6.59666662,14.4434646 6.34109681,13.0864913 L6.34111879,13.0864871 C6.23890192,12.5437565 6.59600887,12.0209233 7.13873948,11.9187064 C7.19976257,11.9072135 7.26172354,11.9014295 7.32381949,11.9014295 L8.95074476,11.9014525 C9.5030422,11.9014525 9.95076774,11.4537269 9.95076774,10.9014295 C9.95076774,10.7847066 9.93033305,10.668885 9.89038907,10.5592095 C9.34007395,9.04819178 9.87436104,8.29268293 11.4932503,8.29268293 C13.1252937,8.29268293 13.7209692,9.04607387 13.2802768,10.5528558 L13.2803062,10.5528644 C13.1252775,11.0829265 13.4293022,11.6383023 13.9593644,11.793331 C14.0505474,11.8199995 14.1450656,11.8335379 14.2400686,11.8335379 L15.6097561,11.8335379",
    id: "Path-36",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29268293,12.195122 L8.29264835,13.2783296 C8.29264835,13.8306335 8.74037908,14.2783642 9.29268293,14.2783642 C9.3473935,14.2783642 9.40201181,14.2738745 9.45598798,14.2649403 C10.6316708,14.0703398 11.2195122,14.528377 11.2195122,15.6390521 C11.2195122,16.7277641 10.6546895,17.1372051 9.52504398,16.8673753 L9.52505198,16.8673418 C8.98786046,16.7390269 8.44836093,17.0704869 8.32004605,17.6076785 C8.30186679,17.6837861 8.29268293,17.7617644 8.29268293,17.8400131 L8.29268293,18.5365854",
    id: "Path-37",
    stroke: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachingIcon);
export default __webpack_public_path__ + "static/media/TeachingIcon.62bde3b0bfe3474b9f2e9187b8c585ea.svg";
export { ForwardRef as ReactComponent };